<template>
	<div id="app">
		<router-view :key="routerKey" />

		<notifications
			classes="custom-notification-styles"
			:ignoreDuplicates="true"
		/>
		<portal-target name="root"></portal-target>
	</div>
</template>

<script>
export default {
	computed: {
		routerKey() {
			const { name, params } = this.$route;

			if (name === "Simulator") {
				const simulationId = params.simulation;
				return simulationId;
			}

			return null;
		},
	},
};
</script>

<style lang="scss">
@import "@/assets/css/index.scss";
</style>
